import React from "react";
import { useTranslation } from "react-i18next";
import css from "./DishDetailsPopup.module.css";
import { ImageReusable } from "../../../../ui";

const DishDetailsPopup = ({ dishData, isOpen, setIsOpen }) => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;

  if (!isOpen || !dishData) return null;

  const {
    name,
    description,
    recipe,
    img,
    energy,
    proteins,
    fats,
    carbs,
    weight,
    weightNetto,
    price,
    cost,
    categories,
  } = dishData;

  const displayName = name?.[currentLanguage] || name?.en || "Unknown Dish";
  const displayDescription =
    description?.[currentLanguage] || description?.en || "";
  const displayRecipe = recipe?.[currentLanguage] || recipe?.en || "";
  const categoryName =
    categories
      .map((category) => category.name[currentLanguage] || category.name["en"])
      .join(", ") || t("unknown-category");

  const closeModal = () => {
    setIsOpen(false);
  };

  return (
    <div className={css.overlay} onClick={closeModal}>
      <div className={css.modal} onClick={(e) => e.stopPropagation()}>
        <div className={css.header}>
          <h2 className={css.title}>{displayName}</h2>
          <button className={css.closeButton} onClick={closeModal}>
            &times;
          </button>
        </div>

        <div className={css.content}>
          <div className={css.imageContainer}>
            <ImageReusable
              src={img}
              alt={displayName}
              className={css.dishImage}
            />
          </div>

          <div className={css.infoContainer}>
            <div className={css.nutritionInfo}>
              <div className={css.nutritionItem}>
                <span className={css.label}>{t("modal-energy")}:</span>
                <span className={css.value}>
                  {energy} {t("calories")}
                </span>
              </div>
              <div className={css.nutritionItem}>
                <span className={css.label}>{t("Weight")}:</span>
                <span className={css.value}>
                  {weight} {t("grams")}
                </span>
              </div>
              {weightNetto && (
                <div className={css.nutritionItem}>
                  <span className={css.label}>{t("weight-netto")}:</span>
                  <span className={css.value}>
                    {weightNetto} {t("grams")}
                  </span>
                </div>
              )}
              <div className={css.nutritionItem}>
                <span className={css.label}>{t("modal-price")}:</span>
                <span className={css.value}>{price}</span>
              </div>
              <div className={css.nutritionItem}>
                <span className={css.label}>{t("Cost")}:</span>
                <span className={css.value}>{cost}</span>
              </div>
              <div className={css.nutritionItem}>
                <span className={css.label}>{t("Category")}:</span>
                <span className={css.value}>{categoryName}</span>
              </div>
            </div>

            <div className={css.macronutrients}>
              <div className={css.macroItem}>
                <span className={css.macroLabel}>{t("modal-proteins")}</span>
                <span className={css.macroValue}>{proteins}g</span>
              </div>
              <div className={css.macroItem}>
                <span className={css.macroLabel}>{t("modal-fats")}</span>
                <span className={css.macroValue}>{fats}g</span>
              </div>
              <div className={css.macroItem}>
                <span className={css.macroLabel}>
                  {t("modal-carbohydrates")}
                </span>
                <span className={css.macroValue}>{carbs}g</span>
              </div>
            </div>

            {displayDescription && (
              <div className={css.section}>
                <h3 className={css.sectionTitle}>{t("Description")}</h3>
                <p className={css.sectionContent}>{displayDescription}</p>
              </div>
            )}

            {displayRecipe && (
              <div className={css.section}>
                <h3 className={css.sectionTitle}>{t("Recipe")}</h3>
                <p className={css.sectionContent}>{displayRecipe}</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export { DishDetailsPopup };
